/* ============================================================
   EDUCARÉ — theme.js
   Menú móvil, carrito lateral (AJAX), ficha de producto (variantes,
   cantidad, galería), el embebido de Instagram cuando entra en pantalla, y
   el único movimiento autorado de la tienda: la raya de plumón que se dibuja
   sobre el carrito cada vez que se agrega algo.
   La medición no vive aquí: llama a window.PSAnalytics.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100); };
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Capas: menú y carrito ---------- */
  function Capa(panel, fondo) {
    this.panel = panel; this.fondo = fondo; this.ultimo = null;
    var self = this;
    if (fondo) fondo.addEventListener('click', function () { self.cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.cerrar(); });
  }
  Capa.prototype.abrir = function (origen) {
    if (!this.panel) return;
    this.ultimo = origen || document.activeElement;
    this.panel.hidden = false; if (this.fondo) this.fondo.hidden = false;
    requestAnimationFrame(function () { this.panel.setAttribute('data-abierto', ''); }.bind(this));
    document.body.style.overflow = 'hidden';
    var foco = this.panel.querySelector('button, a, input');
    if (foco) foco.focus({ preventScroll: true });
  };
  Capa.prototype.cerrar = function () {
    if (!this.panel || this.panel.hidden) return;
    var self = this;
    this.panel.removeAttribute('data-abierto');
    document.body.style.overflow = '';
    var fin = function () { self.panel.hidden = true; if (self.fondo) self.fondo.hidden = true; };
    if (reducido) fin(); else setTimeout(fin, 300);
    if (this.ultimo && this.ultimo.focus) this.ultimo.focus({ preventScroll: true });
  };

  var menu = new Capa($('#menu-movil'), $('#menu-fondo'));
  $$('[data-menu-abrir]').forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-expanded', 'true'); menu.abrir(b); }); });
  $$('[data-menu-cerrar]').forEach(function (b) { b.addEventListener('click', function () { menu.cerrar(); $$('[data-menu-abrir]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); }); });

  /* ---------- Carrito ---------- */
  var Carrito = {
    capa: new Capa($('#carrito-lateral'), $('#carrito-fondo')),
    actual: null,
    init: function () {
      var self = this;
      $$('[data-carrito-abrir]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (window.PSAnalytics) window.PSAnalytics.viewCart(self.actual);
          self.capa.abrir(b);
        });
      });
      $$('[data-carrito-cerrar]').forEach(function (b) { b.addEventListener('click', function () { self.capa.cerrar(); }); });
      $$('[data-agregar]').forEach(function (b) {
        b.addEventListener('click', function () { self.agregar(parseInt(b.getAttribute('data-agregar'), 10), 1, b); });
      });
      var form = $('#formulario-producto');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var id = parseInt(form.querySelector('[data-variante-id]').value, 10);
          var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
          self.agregar(id, qty, form.querySelector('[data-agregar-form]'));
        });
      }
      this.leer();
    },
    leer: function () {
      var self = this;
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        self.actual = cart; self.pintar(cart); return cart;
      }).catch(function () {});
    },
    marcar: function (cart) {
      /* La raya de plumón sobre el carrito, y la paloma sobre la tarjeta del producto. */
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      var ids = {};
      (cart.items || []).forEach(function (l) { ids[l.product_id] = true; });
      $$('.tarjeta[data-product-id]').forEach(function (t) { t.classList.toggle('tarjeta--en-carrito', !!ids[t.getAttribute('data-product-id')]); });
    },
    raya: function () {
      var b = $('.encabezado__carrito');
      if (!b) return;
      b.classList.remove('marcando'); void b.offsetWidth; b.classList.add('marcando');
      setTimeout(function () { b.classList.remove('marcando'); }, 900);
    },
    pintar: function (cart) {
      this.marcar(cart);
      var lista = $('#carrito-lineas'), vacio = $('#carrito-vacio'), pie = $('#carrito-pie'), sub = $('#carrito-subtotal');
      if (!lista) return;
      if (!cart.item_count) { lista.innerHTML = ''; vacio.hidden = false; pie.hidden = true; return; }
      vacio.hidden = true; pie.hidden = false; sub.textContent = money(cart.total_price);
      lista.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120_crop_center$1$2') + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>';
        var variante = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="carrito-linea__variante">' + item.variant_title + '</div>' : '';
        return '<li class="carrito-linea" data-key="' + item.key + '">' + img +
          '<div><div class="carrito-linea__titulo">' + item.product_title + '</div>' + variante +
          '<div class="carrito-linea__precio">' + money(item.final_price) + ' c/u</div>' +
          '<div class="carrito-linea__controles">' +
          '<button type="button" data-cambiar="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Una menos">−</button>' +
          '<span aria-live="polite">' + item.quantity + '</span>' +
          '<button type="button" data-cambiar="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Una más">+</button>' +
          '<button type="button" class="carrito-linea__quitar" data-cambiar="' + item.key + '" data-qty="0">Quitar</button>' +
          '</div></div></li>';
      }).join('');
      var self = this;
      $$('[data-cambiar]', lista).forEach(function (b) {
        b.addEventListener('click', function () { self.cambiar(b.getAttribute('data-cambiar'), parseInt(b.getAttribute('data-qty'), 10)); });
      });
    },
    agregar: function (variantId, qty, boton) {
      var self = this;
      if (boton) { boton.disabled = true; boton.dataset.texto = boton.textContent; boton.textContent = 'Agregando…'; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (added) {
          if (window.PSAnalytics) window.PSAnalytics.addToCart([added]);
          return self.leer();
        })
        .then(function () { self.raya(); self.capa.abrir(boton); })
        .catch(function () { alert('No pudimos agregarlo al carrito. Intenta de nuevo o escríbenos por WhatsApp.'); })
        .then(function () { if (boton) { boton.disabled = false; boton.textContent = boton.dataset.texto || 'Agregar al carrito'; } });
    },
    cambiar: function (key, qty) {
      var self = this;
      if (qty === 0 && this.actual && window.PSAnalytics) {
        var gone = (this.actual.items || []).filter(function (i) { return i.key === key; })[0];
        if (gone) window.PSAnalytics.removeFromCart(window.PSAnalytics.itemFromCartLine(gone));
      }
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.ok ? self.leer() : null; }).catch(function () {});
    }
  };
  window.EducareCarrito = Carrito;

  /* ---------- Ficha de producto ---------- */
  var Producto = {
    init: function () {
      var form = $('#formulario-producto');
      if (!form) return;
      var self = this;
      $$('[data-cantidad]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('#cantidad'); var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-cantidad'), 10);
          input.value = Math.max(1, v);
        });
      });
      var datos = $('[data-variantes]');
      if (datos) {
        this.variantes = JSON.parse(datos.textContent);
        $$('[data-opcion]').forEach(function (s) { s.addEventListener('change', function () { self.elegir(); }); });
      }
      $$('.producto__miniatura').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = $('#producto-imagen'); if (!img) return;
          img.src = b.getAttribute('data-imagen'); img.removeAttribute('srcset'); img.alt = b.getAttribute('data-alt') || '';
          $$('.producto__miniatura').forEach(function (x) { x.classList.remove('producto__miniatura--activa'); });
          b.classList.add('producto__miniatura--activa');
        });
      });
    },
    elegir: function () {
      var valores = $$('[data-opcion]').map(function (s) { return s.value; });
      var v = this.variantes.filter(function (x) { return x.options.every(function (o, i) { return o === valores[i]; }); })[0];
      var boton = $('[data-agregar-form]'), precio = $('#producto-precio .precio__actual'), exist = $('#producto-existencia');
      if (!v) { if (boton) { boton.disabled = true; boton.textContent = 'No disponible'; } return; }
      $('[data-variante-id]').value = v.id;
      if (precio) precio.textContent = money(v.price);
      if (exist) { exist.textContent = v.available ? 'Disponible' : 'Agotado por ahora'; exist.classList.toggle('existencia--si', v.available); exist.classList.toggle('existencia--no', !v.available); }
      if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      if (v.featured_image && v.featured_image.src) { var img = $('#producto-imagen'); if (img) { img.src = v.featured_image.src; img.removeAttribute('srcset'); } }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
  };

  /* ---------- Instagram: el embebido del perfil, solo cuando se ve ----------
     El iframe es de un tercero y no va en el HTML: se inserta cuando la sección
     está a una pantalla de distancia. El embebido de perfil trae una cabecera
     (avatar, seguidores) de unos 150 px y debajo dos filas de fotos cuadradas a
     un tercio del ancho. La cabecera se esconde desplazando el iframe hacia
     arriba dentro de un hueco con overflow oculto, así la lámina enseña solo
     las seis fotos; las medidas salen del ancho real para que no quede corte
     ni hueco. */
  var Instagram = {
    CABECERA: 146,
    init: function () {
      var marcos = $$('[data-instagram]');
      if (!marcos.length) return;
      var self = this;
      if (!('IntersectionObserver' in window)) { marcos.forEach(function (m) { self.montar(m); }); return; }
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { if (e.isIntersecting) { self.montar(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '600px 0px' });
      marcos.forEach(function (m) { io.observe(m); });
    },
    montar: function (marco) {
      var hueco = $('[data-instagram-embebido]', marco);
      if (!hueco || hueco.firstChild) return;
      var usuario = marco.getAttribute('data-instagram');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.instagram.com/' + encodeURIComponent(usuario) + '/embed/';
      iframe.title = 'Últimas publicaciones de @' + usuario + ' en Instagram';
      iframe.loading = 'lazy';
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('allowtransparency', 'true');
      hueco.appendChild(iframe);
      var ajustar = function () { Instagram.medir(hueco, iframe); };
      ajustar();
      window.addEventListener('resize', ajustar);
    },
    medir: function (hueco, iframe) {
      var ancho = hueco.clientWidth || 600;
      var fotos = Math.round(2 * (ancho / 3) + 6);
      hueco.style.height = fotos + 'px';
      iframe.style.height = (this.CABECERA + fotos + 40) + 'px';
      iframe.style.marginTop = '-' + this.CABECERA + 'px';
    }
  };

  /* ---------- Orden de colección sin botón ---------- */
  var orden = $('[data-orden]');
  if (orden) orden.addEventListener('change', function () { orden.form.submit(); });

  document.documentElement.classList.remove('no-js');
  Carrito.init();
  Producto.init();
  Instagram.init();
})();
